/**
 * BhiPhaseHeader.jsx — iter846 (Feb 2026)
 *
 * Extracted from BreastHealthIntelligencePage.jsx. Patient-centric phase
 * divider used to group BHI sections into 6 educational phases (Assess →
 * Observe → Understand → Plan → Act → Support).
 */
import React from "react";

export default function BhiPhaseHeader({ emoji, title, subtitle, anchorId }) {
  return (
    <div
      className="my-6 first:mt-2 scroll-mt-24"
      id={anchorId ? `phase-${anchorId}` : undefined}
      data-anchor={anchorId}
      data-testid={`phase-${anchorId || title?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-center gap-3">
        <span className="text-3xl">{emoji}</span>
        <div className="h-px flex-1 bg-gradient-to-r from-pink-500/40 via-purple-500/30 to-transparent" />
      </div>
      <h2 className="mt-2 text-2xl sm:text-3xl font-extrabold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
        {title}
      </h2>
      {subtitle && <p className="text-xs opacity-60 mt-1">{subtitle}</p>}
    </div>
  );
}
